import React from 'react';
import { User, Search } from 'lucide-react';

function SellersList({ sellers, selectedSeller, onSelectSeller, searchTerm, onSearchChange, loading }) {
  const filteredSellers = sellers.filter(seller => 
    seller.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    seller.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 h-full flex flex-col">
      <div className="p-4 border-b border-slate-200">
        <h3 className="text-sm font-bold text-slate-900 font-montserrat mb-3 flex items-center gap-2">
          <User className="w-4 h-4 text-[#B1336E]" />
          Vendedores
        </h3>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input
            type="text"
            placeholder="Buscar vendedor..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-9 pr-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
          />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        {loading ? (
          <div className="flex items-center justify-center p-8">
            <div className="w-8 h-8 border-4 border-[#B1336E] border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : filteredSellers.length === 0 ? (
          <div className="p-6 text-center">
            <p className="text-sm text-slate-500 font-montserrat">No se encontraron vendedores</p>
          </div>
        ) : (
          <div className="p-2">
            {filteredSellers.map((seller) => (
              <button
                key={seller.id}
                onClick={() => onSelectSeller(seller)}
                className={`w-full text-left p-3 rounded-lg mb-2 transition-all duration-200 font-montserrat ${
                  selectedSeller?.id === seller.id
                    ? 'bg-gradient-to-r from-[#B1336E]/10 to-[#E6B43C]/10 border-2 border-[#B1336E]'
                    : 'hover:bg-slate-50 border-2 border-transparent'
                }`}
              >
                <p className="text-sm font-semibold text-slate-900 truncate">
                  {seller.username || `Usuario ${seller.id}`}
                </p>
                {seller.email && (
                  <p className="text-xs text-slate-500 truncate">{seller.email}</p>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SellersList;